import styled from 'styled-components'
import ReactSelect from 'react-select'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  small?: boolean
}

export const Div = styled.div`
  border: 1px solid green;
`

export const Select = styled(ReactSelect)`
  width: 10px;
`

export const Checkbox = styled.input`
  width: 10px;
`

export const Label = styled.label`
  border: 1px solid red;
`
